import {useTheme} from '@mui/material';
import type {DotProps} from './Dot';
import {Dot} from './Dot';

type Props = Omit<DotProps, 'color'>;

export const WarningDot: React.FC<Props> = props => {
  const {palette} = useTheme();
  return <Dot color={palette.warning.main} {...props} />;
};
